interface Step8DoneProps {
    onClose: () => void;
    email?: string;
    isLoggedIn: boolean;
    /** The noun that completes "match you with 2–3 …" — e.g. "professionals", "projects", "products and suppliers". */
    matchSubjectPlural: string;
}

export const Step8Done = ({
    onClose,
    email,
    isLoggedIn,
    matchSubjectPlural,
}: Step8DoneProps) => {
    return (
        <div className="flex flex-col gap-7 pt-2">
            <span
                aria-hidden
                className="flex size-10 items-center justify-center bg-[#161616] text-[1.25rem] font-bold text-white"
            >
                ✓
            </span>
            <h2 className="font-display text-[2rem] leading-[0.9] font-bold tracking-[-0.02em] text-[#161616] uppercase">
                <span className="block font-normal">Brief</span>
                <span className="block">Received.</span>
            </h2>
            <p className="text-[0.875rem] leading-[1.3] tracking-[-0.02em] text-black">
                <span className="font-bold">Thank you.</span> Our team will
                review your brief and personally match you with 2–3{' '}
                {matchSubjectPlural} whose work, availability, and approach
                align with your project. You&apos;ll hear from us within 2
                business days.
            </p>
            {isLoggedIn ? (
                <p className="text-[0.875rem] leading-[1.3] tracking-[-0.02em] text-black">
                    You can track the status of your request any time in your{' '}
                    <a
                        href="/member/get-matched-requests"
                        className="font-bold underline"
                    >
                        member portal
                    </a>
                    .
                </p>
            ) : null}
            <div className="flex items-center gap-2 pt-2">
                <span aria-hidden className="h-px w-4 bg-[#858585]" />
                <span className="text-[0.7rem] font-medium tracking-[-0.02em] text-[#929292] uppercase">
                    {email
                        ? `A confirmation has been sent to ${email}`
                        : 'A confirmation has been sent to your email'}
                </span>
            </div>
            <div className="flex-1" />
            <div className="flex justify-center">
                <button
                    type="button"
                    onClick={onClose}
                    className="inline-flex h-[2.85rem] items-center justify-center rounded-full bg-[#323232] px-9 text-[1rem] font-medium tracking-[0.02em] text-white shadow-md transition-colors hover:bg-black"
                >
                    Close
                </button>
            </div>
        </div>
    );
};
